import { request } from "./request";
import { notify } from "./notify";
import { modal, cModal } from "./modal";
import { languages } from "./../app";

export const manageTags = async (tags, button) => {
	try {
		const response = await request(
			{
				reqId: "fcc1be2a-3c7f-464c-b471-21817032c8b2",
				type: "tagList",
				id: "tagList"
			},
			button
		);
		tags = response.tags;
	} catch (err) {
		console.error(err);
		notify("There was an error fetching tags", "danger");
	}
	const tagModal = modal(`<h3>Manage tags</h3>
        <div>
            <button class="uk-button uk-button-primary" id="save-tags">Save changes</button>
            <button class="uk-button uk-button-danger uk-modal-close uk-margin-small-left">Cancel</button>
        </div>
        <p>Click <span uk-icon="trash" class="text-utility-red"></span> next to a tag name to remove it.</p><p><span class="bold">NO</span> changes you make will be saved until you click the "Save Changes" button!</p>
        <div class="uk-margin-small">
            ${Object.keys(tags)
				.map(
					lang => `<h4 class="uk-margin-remove-bottom">${languages[lang]}</h4>
                <div class="tag-group-wrapper" data-lang="${lang}">
                    ${tags[lang].map((tag, index) => `<span style="font-size: .7em;" data-lang="${lang}" data-index="${index}" data-tag="${tag}" class="tag-wrapper uk-inline-block uk-margin-small-right"><span class="tag pointer">${tag}</span> <span uk-icon="trash" class="pointer delete-tag text-utility-red"></span></span>`).join("")}
                 </div>
                <div class="field uk-margin-small-top">
                    <label for="${lang}-new-tag" class="uk-display-block" style="font-size: .8em;">Add a new ${languages[lang]} tag</label>
                    <input type="text" class="uk-input uk-width-auto new-tag" data-lang="${lang}" id="${lang}-new-tag" name="${lang}-new-tag" /> <button class="uk-button uk-button-primary uk-button-small new-tag-submit">Submit</button>
                </div>`
				)
				.join("")}
        </div>                
        <style>
            svg {
                pointer-events: none;
            }
        </style>`);

	$("#save-tags").on("click", async function () {
		await cModal();
		const response = await request(
			{
				reqId: "4b9d14f5-1255-4f03-8b6a-da2363fe25ee",
				data: [
					{
						PutRequest: {
							Item: {
								type: "tagList",
								id: "tagList",
								tags: tags
							}
						}
					}
				]
			},
			$(this)
		);
		notify("Tag list updated", "success");
		UIkit.modal(tagModal).hide();
	});

	tagModal.on("click", function (e) {
		// if ($(e.target).hasClass("tag")) {
		//     editTag(e.target)
		// }
		if ($(e.target).hasClass("delete-tag")) {
			e.stopImmediatePropagation();
			deleteTag(e.target);
		}
		if ($(e.target).hasClass("new-tag-submit")) {
			newTag(e.target);
		}
	});

	async function editTag(el) {
		const wrapper = $(el).parents(".tag-wrapper");
		const index = parseInt(wrapper.attr("data-index"));
		const lang = wrapper.attr("data-lang");
		const tagVal = $(el).text();
		const newVal = await UIkit.modal.prompt("Tag value:", tagVal);
		if (newVal) {
			tags[lang][index] = newVal;
			wrapper.attr("data-tag", newVal);
			$(el).text(newVal);
		}
	}

	function deleteTag(el) {
		const wrapper = $(el).parents(".tag-wrapper");
		const lang = wrapper.attr("data-lang");
		const index = parseInt(wrapper.attr("data-index"));
		tags[lang].splice(index, 1);
		$(el).parents(".tag-wrapper").remove();
	}

	function newTag(el) {
		const input = $(el).siblings("input.new-tag");
		if (input.val()) {
			const newVal = input.val();
			const lang = input.attr("data-lang");
			tags[lang].push(newVal);
			$(`.tag-group-wrapper[data-lang='${lang}']`).append(`<span style="font-size: .7em;" data-lang="${lang}" data-index="${tags[lang].length}" data-tag="${newVal}" class="tag-wrapper uk-inline-block uk-margin-small-right"><span class="tag pointer">${newVal}</span> <span uk-icon="trash" class="pointer delete-tag text-utility-red uk-icon"></span></span>`);
		}
	}
	// delegated event handlers
};
